import React from 'react';
import { unstable_HistoryRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AppLayout from './Layout/AppLayout';
import { Suspense,lazy} from 'react';
import '@fontsource/lato';
import Loader from './AppAssets/Loader.gif';
import ForgotPassword from './Pages/ForgotPassword';
import PrivateRoute from './AppRoutes/PrivateRoute';
import { AuthContextProvider } from './AppContext/AuthContext';
import { CorporateFacilityContextProvider } from './AppContext/CorporateFacilityContext';
import { ShareContextProvider } from './AppContext/ShareContext';
import { ContentContextProvider } from './AppContext/ContentContext';
import { CreatorsSharedContextProvider } from './AppContext/CreatorsSharedTemplateContext';
import { ProfileContextProvider } from './AppContext/ProfileContext';
import ConfirmEmail from './Pages/ConfirmEmail';
import Redirect from './Pages/Redirect';
import ResetPassword from './Pages/ResetPassword';
import Speak2Redirect from './Pages/Speak2Redirect';
import { history } from './RoutingUtils/History.js';
import { QuickPrintsContextProvider } from './AppContext/QuickPrintsContext.js';
import { LoaderProvider } from './AppContext/LoaderProvider.js';
import RenderTemplateForImage from './Pages/RenderTemplateForImage';
import PageViewTracker from './AppComponents/PageViewTracker.jsx';
import RootRoute from './AppRoutes/RootRoute.jsx';









const Community=lazy(() => import('./Pages/Community'));
const MediaLibrary = lazy(() => import('./Pages/MediaLibrary'));
const  QuickPrnts =lazy(() => import('./Pages/QuickPrnts'));
const CalendarApp = lazy(() => import('./Apps/CalendarApp/CalendarApp'));
const CalendarStudioApp = lazy(() => import('./Apps/CalendarStudioApp/CalendarStudioApp'));
const SlideApp = lazy(() => import('./Apps/SlideApp/SlideApp'));
const NewsLetterApp = lazy(() => import('./Apps/NewsLetterApp/NewsLetterApp'));
const UserProfile = lazy(() => import('./Pages/UserProfile'));
const CorporateCommunities = lazy(() => import('./Pages/CorporateCommunities'));









const AppShell = () => (
  <AuthContextProvider>
    <CorporateFacilityContextProvider>
    <ProfileContextProvider>
      <ShareContextProvider>
        <ContentContextProvider>
          <CreatorsSharedContextProvider>
            <QuickPrintsContextProvider>
              <AppLayout>
                <PageViewTracker />
                <Suspense fallback={<div className='relative content-center h-screen'><img className='absolute top-1/2 left-1/2 h-24 2-34' src={Loader} alt="Loading...please wait" /></div>}>
                  <Outlet />
                </Suspense>
              </AppLayout>
            </QuickPrintsContextProvider>
          </CreatorsSharedContextProvider>
        </ContentContextProvider>
      </ShareContextProvider>
    </ProfileContextProvider>
    </CorporateFacilityContextProvider>
  </AuthContextProvider>
);

function App() {
  return (
    <div style={{backgroundColor:"#FFFFFF"}}>
      <ToastContainer position="bottom-center" />
      <LoaderProvider>
        <Router history={history}>
          <Routes>
            <Route path="/render-template" element={<RenderTemplateForImage />} />
            <Route element={<AppShell />}>
              <Route path="/" element={<RootRoute />} />
              <Route
                exact
                path="/corporate-communities"
                element={
                  <PrivateRoute>
                    <CorporateCommunities />
                  </PrivateRoute>
                }
              />
              <Route exact path="/newsletterapp" element={<PrivateRoute><NewsLetterApp /></PrivateRoute>} />
              <Route exact path="/slideapp" element={<PrivateRoute><SlideApp /></PrivateRoute>} />
              <Route exact path="/calendarapp" element={<PrivateRoute><CalendarStudioApp /></PrivateRoute>} />
              <Route exact path="/calendarapp-legacy" element={<PrivateRoute><CalendarApp /></PrivateRoute>} />
              <Route exact path="/designs" element={<PrivateRoute><Community /></PrivateRoute>} />
              <Route exact path="/medialibrary" element={<PrivateRoute><MediaLibrary /></PrivateRoute>} />
              <Route exact path="/quickprnts" element={<PrivateRoute><QuickPrnts /></PrivateRoute>} />
              <Route exact path="/profile" element={<PrivateRoute><UserProfile /></PrivateRoute>} />
              <Route exact path="/forgotpassword" element={<ForgotPassword />} />
              <Route exact path="/confirmemail" element={<ConfirmEmail />} />
              <Route exact path="/redirect" element={<Redirect />} />
              <Route exact path="/speak2-redirect" element={<Speak2Redirect />} />
              <Route exact path="/resetpassword" element={<ResetPassword />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </Router>
      </LoaderProvider>
    </div>
  );
}

export default App;
